package fr.manyverse.app.domain.usecase

/**
 * Use case for closing the lockpicking overlay locally (player action after SUCCESS/TIMEOUT/CANCELLED).
 * This is a local-only operation — no database call needed.
 */
class CloseLockpickingUseCase {
    operator fun invoke() {
        // Local-only: clears local state, no network call needed
    }
}
